import React from 'react';
import { Typography } from 'antd';

const { Title, Paragraph } = Typography;

const baseStyle = {
  fontFamily: 'Roboto, sans-serif',
};

const headingStyle = {
  ...baseStyle,
  fontWeight: 600,
  lineHeight: 1.2,
  marginTop: '1.66em',
  marginBottom: '0.66em',
};

export const H1: React.FC<React.ComponentProps<typeof Title>> = ({ style, ...props }) => (
  <Title 
    level={1} 
    style={{ ...headingStyle, fontSize: '36px', ...style,  marginTop: '0' }} 
    {...props} 
  />
);

export const H2: React.FC<React.ComponentProps<typeof Title>> = ({ style, ...props }) => (
  <Title 
    level={2} 
    style={{ ...headingStyle, fontSize: '24px', ...style }} 
    {...props} 
  />
);

export const H3: React.FC<React.ComponentProps<typeof Title>> = ({ style, ...props }) => (
  <Title 
    level={3} 
    style={{ ...headingStyle, fontSize: '20px', ...style }} 
    {...props} 
  />
);

export const H4: React.FC<React.ComponentProps<typeof Title>> = ({ style, ...props }) => (
  <Title 
    level={4} 
    style={{ ...headingStyle, fontSize: '18px', ...style }} 
    {...props} 
  />
);

export const BodyText: React.FC<React.ComponentProps<typeof Paragraph>> = ({ style, ...props }) => (
  <Paragraph 
    style={{ 
      ...baseStyle, 
      fontSize: '16px', 
      lineHeight: 1.85, 
      marginBottom: '0.66em',
      ...style 
    }} 
    {...props} 
  />
);

export const SmallText: React.FC<React.ComponentProps<typeof Paragraph>> = ({ style, ...props }) => (
  <Paragraph 
    style={{ 
      ...baseStyle, 
      fontSize: '12px', 
      fontWeight: 400, 
      lineHeight: 1.5, 
      marginBottom: '0.66em',
      ...style 
    }} 
    {...props} 
  />
);

const CustomTypography = {
  H1,
  H2,
  H3,
  H4,
  BodyText,
  SmallText,
};

export default CustomTypography;